<template>
    <div class="header-container">
        <img class="bg" :src="home_content_title">
        <div class="header-wrap">
            <div class="left">
                <div class="date">
                    <div class="text">{{week||''}}</div>
                    <div class="text">{{date||''}}</div>
                </div>
                <div class="time">{{time||''}}</div>
            </div>
            <div class="right" v-if="Login">
                <div class="name">{{UserInfo&&UserInfo.nickname?UserInfo.nickname:''}}</div>
                <div class="btn" @click="loOut">退出</div>
            </div>
            <div class="right" v-else>
                <div class="name" @click="goLogin">未登录</div>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        data() {
            return {
                timer: null,
                week: '',
                date: '',
                time: '',
                home_content_title: ''
            }
        },
        watch: {
            '$route'(n) {
                if (n && n.name !== 'Common.Home') {
                    // 离开页面
                    clearInterval(this.timer)
                }
            }
        },
        activated() {
            clearInterval(this.timer)
            this.getDate()
            this.timer = setInterval(() => {
                this.getDate()
            }, 1000)
        },
        mounted() {
            this.getTitleImg()
        },
        methods: {
            getDate() {
                let weekArr = ['日', '一', '二', '三', '四', '五', '六']
                let n = dayjs()
                this.week = `星期${weekArr[dayjs().day()]}`
                this.date = `${n.format('YYYY-MM-DD')}`
                this.time = `${n.format('HH:mm')}`
            },
            goLogin() {
                this.$nav('Common.Login')
            },
            getTitleImg() {
                this.$Get('Common.getTitleImg').then(res => {
                    if (res.status) {
                        this.home_content_title = res.data.home_content_title || ''
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .header-container {
        position: relative;
        width: 100%;
        height: 90px;

        .bg {
            z-index: 1;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
        }

        .header-wrap {
            z-index: 10;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            width: 100%;
            height: 100%;

            .left {
                display: flex;
                align-items: center;
                // padding: 0 30px;

                .date {
                    margin-right: 14px;

                    .text {
                        &:first-child {
                            margin-bottom: 8px;
                        }

                        line-height: 1;
                        font-size: 12px;
                        color: #ffffff;
                    }
                }

                .time {
                    font-size: 36px;
                    color: #17cafc;
                    font-weight: bold;
                }
            }

            .right {
                display: flex;
                align-items: center;
                height: 100%;

                .name {
                    display: flex;
                    align-items: center;
                    height: 100%;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    color: #01b3e4;

                    &::before {
                        content: " ";
                        display: inline-block;
                        margin-right: 12px;
                        width: 20px;
                        height: 24px;
                        background-image: url("/static/images/home/user.png");
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                }

                .btn {
                    display: flex;
                    align-items: center;
                    margin-left: 15px;
                    // padding: 0 30px;
                    padding-left: 30px;
                    height: 100%;
                    font-size: 14px;
                    color: #ef9302;
                    cursor: pointer;

                    &::before {
                        content: " ";
                        display: inline-block;
                        margin-right: 4px;
                        width: 20px;
                        height: 24px;
                        background-image: url("/static/images/home/loout.png");
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                }
            }
        }
    }
</style>
